import type { InsuranceEvent, InsuranceEventStatus } from '~/api/types/insuranceEvent'

export type InsuranceEventProcessStatus =
  | 'WAITING_APPRAISAL'
  | 'WAITING_INVOICE'
  | 'WAITING_PAYMENT'
  | 'CLOSED'

export const insuranceEventProcessStatusOptions: { title: string; value: InsuranceEventProcessStatus }[] = [
  { title: 'Čeká na odhad', value: 'WAITING_APPRAISAL' },
  { title: 'Čeká na fakturaci', value: 'WAITING_INVOICE' },
  { title: 'Čeká na úhradu', value: 'WAITING_PAYMENT' },
  { title: 'Uzavřeno', value: 'CLOSED' }
]

export const insuranceEventProcessStatusLabels: Record<InsuranceEventProcessStatus, string> = {
  WAITING_APPRAISAL: 'Čeká na odhad',
  WAITING_INVOICE: 'Čeká na fakturaci',
  WAITING_PAYMENT: 'Čeká na úhradu',
  CLOSED: 'Uzavřeno'
}

export const insuranceEventProcessStatusColors: Record<InsuranceEventProcessStatus, string> = {
  WAITING_APPRAISAL: 'warning',
  WAITING_INVOICE: 'purple',
  WAITING_PAYMENT: 'info',
  CLOSED: 'grey-darken-1'
}

export const insuranceEventProcessStatusPriority: Record<InsuranceEventProcessStatus, number> = {
  WAITING_APPRAISAL: 0,
  WAITING_INVOICE: 1,
  WAITING_PAYMENT: 2,
  CLOSED: 3
}

export const insuranceEventProcessStatusNextValid: Record<InsuranceEventProcessStatus, InsuranceEventProcessStatus[]> = {
  WAITING_APPRAISAL: ['WAITING_INVOICE', 'CLOSED'],
  WAITING_INVOICE: ['WAITING_PAYMENT', 'CLOSED'],
  WAITING_PAYMENT: ['CLOSED'],
  CLOSED: []
}

const FE_TO_BE: Record<InsuranceEventProcessStatus, InsuranceEventStatus> = {
  WAITING_APPRAISAL: 'REPORTED',
  WAITING_INVOICE: 'IN_PROGRESS',
  WAITING_PAYMENT: 'APPROVED',
  CLOSED: 'CLOSED'
}

export function toBEInsuranceEventStatus(ps: InsuranceEventProcessStatus): InsuranceEventStatus {
  return FE_TO_BE[ps]
}

const BE_TO_FE_FALLBACK: Record<InsuranceEventStatus, InsuranceEventProcessStatus> = {
  REPORTED: 'WAITING_APPRAISAL',
  IN_PROGRESS: 'WAITING_INVOICE',
  APPROVED: 'WAITING_PAYMENT',
  REJECTED: 'CLOSED',
  CLOSED: 'CLOSED'
}

export function resolveInsuranceEventProcessStatus(
  ev: Pick<InsuranceEvent, 'status' | 'customData'>
): InsuranceEventProcessStatus {
  const ps = (ev.customData as { processStatus?: InsuranceEventProcessStatus } | undefined)?.processStatus
  if (ps && ps in insuranceEventProcessStatusLabels) return ps
  return BE_TO_FE_FALLBACK[ev.status] ?? 'WAITING_APPRAISAL'
}

export interface InsuranceEventStatusHistoryEntry {
  at: number
  by?: string
  from: InsuranceEventProcessStatus
  to: InsuranceEventProcessStatus
}
